var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24988 3.96905H6.40457V9.25499C6.40457 9.32374 6.46082 9.37999 6.52957 9.37999H7.46707C7.53582 9.37999 7.59207 9.32374 7.59207 9.25499V3.96905H8.74988C8.85457 3.96905 8.91238 3.84874 8.84832 3.76749L7.09832 1.55187C7.08662 1.53693 7.07168 1.52484 7.05463 1.51653C7.03757 1.50822 7.01885 1.50391 6.99988 1.50391C6.98091 1.50391 6.96218 1.50822 6.94513 1.51653C6.92807 1.52484 6.91313 1.53693 6.90144 1.55187L5.15144 3.76593C5.08738 3.84874 5.14519 3.96905 5.24988 3.96905ZM12.7186 8.78624H11.7811C11.7124 8.78624 11.6561 8.84249 11.6561 8.91124V11.3175H2.34363V8.91124C2.34363 8.84249 2.28738 8.78624 2.21863 8.78624H1.28113C1.21238 8.78624 1.15613 8.84249 1.15613 8.91124V12.005C1.15613 12.2816 1.37957 12.505 1.65613 12.505H12.3436C12.6202 12.505 12.8436 12.2816 12.8436 12.005V8.91124C12.8436 8.84249 12.7874 8.78624 12.7186 8.78624Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.42c5079bb788baaa63e4d6b3a107251f.svg";
export { ForwardRef as ReactComponent };